import { FC, useMemo, useEffect } from 'react';
import SimpleMDE from 'react-simplemde-editor';
import { type SimpleMDEReactProps } from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';
import { Box } from '@mui/material';
import { useEditor } from './EditorContext';

const Editor: FC<{ placeholder: string; minHeight?: string }> = ({
  placeholder,
  minHeight = '1.5em',
}) => {
  const { comment, handleCommentChange, mdeInstance, setMdeInstance } = useEditor();

  const getMdeInstance: SimpleMDEReactProps['getMdeInstance'] = (instance) => {
    setMdeInstance(instance);
  };

  const editorOptions = useMemo(
    () =>
      ({
        placeholder,
        spellChecker: false,
        toolbar: false,
        status: false,
        minHeight: minHeight,
        autofocus: false,
        autoDownloadFontAwesome: false,
      }) as any,
    [placeholder, minHeight],
  );

  useEffect(() => {
    if (mdeInstance) {
      (window as any).__composerMde = mdeInstance;
    }
    return () => {
      delete (window as any).__composerMde;
    };
  }, [mdeInstance]);

  return (
    <Box
      sx={{
        flex: 1,
        '& .EasyMDEContainer': {
          display: 'flex',
          flexDirection: 'column',
          border: 'none',
          outline: 'none',
        },
        '& .EasyMDEContainer .CodeMirror': {
          border: 'none',
          fontSize: '0.9375rem',
          fontFamily: 'Manrope, sans-serif',
          color: '#162936',
          padding: '6px 10px',
          height: 'auto',
          minHeight: 'unset',
        },
        '& .EasyMDEContainer .CodeMirror-scroll': {
          minHeight: 'unset',
          maxHeight: '120px',
          overflowY: 'auto !important',
        },
        '& .EasyMDEContainer .CodeMirror-focused': {
          borderColor: 'none',
          boxShadow: 'none',
        },
        '& .editor-toolbar': { display: 'none' },
        '& .editor-statusbar': { display: 'none' },
      }}
    >
      <SimpleMDE
        value={comment}
        onChange={handleCommentChange}
        options={editorOptions}
        getMdeInstance={getMdeInstance}
      />
    </Box>
  );
};

export default Editor;
